// Shared by every recovery action so the rows line up: one equal-width outline
// button per row with its explanation to the right. Both actions are outline
// buttons — neither should read as the page's primary call to action.
export const recoveryActionRowClassName =
  'flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-4';

// brand-red, not brand-primary: since the Gesprekskompas palette landed,
// brand-primary is the warm beige page background, which rendered these
// buttons as beige-on-white.
export const recoveryActionButtonClassName =
  'inline-flex w-full items-center justify-center gap-2 rounded-lg border-2 border-brand-red bg-white px-4 py-2.5 text-sm font-semibold text-brand-red transition-colors hover:bg-brand-red hover:text-brand-beige disabled:border-gray-300 disabled:bg-gray-100 disabled:text-gray-500 sm:w-60 sm:shrink-0';

export const recoveryActionExplainerClassName = 'text-xs text-gray-600 sm:flex-1';
